import { memo, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
import { OutletIProps } from '../../../components/sitebase/Base.types';
import EventsApp from './apps/events/EventsApp';
import setTitle from '../../../components/common/SetTitle';


const links = [
    { name: 'Get Involved', url: `/get-involved` },
    { name: 'Events', url: `/get-involved/events`, active: true },
];

export default memo(function GlofasEventsPage() {
    const { setExtraMenuLinks } = useOutletContext<OutletIProps>();

    useEffect(() => {
        setExtraMenuLinks(links);
        setTitle("Events")
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [setExtraMenuLinks]);

    return <Container>
        <h3 className="mt-2 mb-4" style={{ borderBottom: '1px solid orange' }}>GloFAS and GFM Events</h3>
        <EventsApp />
    </Container>;
})
